import { connect } from 'react-redux'

import PublishValid from './PublishValid'
import type { RootState } from '../../Store/rootReducer'

const connectedComponent = connect((state: RootState) => {
  return {
    list: state.lists.byId[state.ui.id as string],
    items: state.lists.byId[state.ui.id as string].items.map(
      (item) => state.items.byId[item]
    ),
  }
}, {})(PublishValid)

export default connectedComponent
